/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { v1 as uuidv1 } from 'uuid';

import AsyncAutoComplete from './AsyncAutoComplete';

const data = [
  {
    opex_capex_code: 'OPEX',
    opex_capex_value: 'OPEX',
  },
  {
    opex_capex_code: 'CAPEX',
    opex_capex_value: 'CAPEX',
  },
  {
    opex_capex_code: 'COGS',
    opex_capex_value: 'COGS',
  },
];

function OpexCapexField({
  // attributes
  style,
  placeholder,
  disabled,

  // object attributes
  config: {},

  // methods
  onInputSelect,
}) {
  const [key, setKey] = useState(uuidv1());
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setKey(uuidv1());
    setOptions([]);
  }, []);

  useEffect(() => {
    setOptions(data.map(({
      opex_capex_code,
      opex_capex_value,
    }) => ({
      value: opex_capex_code,
      label: opex_capex_value,
    })));
  }, [data]);

  return (
    <AsyncAutoComplete
      key={key}
      style={style}
      placeholder={placeholder}
      disabled={disabled}
      options={options}
      onInputSelect={(item) => {
        if (data) {
          onInputSelect(data.find(({ opex_capex_code }) => opex_capex_code === item));
        }
      }}
    />
  );
}

export default OpexCapexField;
